import axios from 'axios';
import { SERVER } from '../../constants/networkUrls';
import apiConfig from '../trustBuilder/Auth/services/apiConfig';


const getQRSession = (update, isFormSubmitted, isValidExcel, isPdfGenerated) => {
    return new Promise((resolve, reject) => {
        let getSessionURL = "";
        const hostname = window && window.location && window.location.hostname;
        const environmentConstants = apiConfig.setEnvironmentURLs(hostname);
        let authConfig = {
            headers: {
                "X-API-KEY": environmentConstants.apiKey,
                'Content-Type': 'application/json',
            }
        };
        const timestamp = new Date().toISOString();

        if (update) {
            let sessionIdStored = getQRSessionId();
            let postBody = {
                qrSessionId: sessionIdStored,
                isFormSubmitted: isFormSubmitted,
                isValidExcel: isValidExcel,
                isPdfGenerated: isPdfGenerated,
                pdfGenerationDateTime: timestamp,
                createdDateTime: timestamp,
                modifiedDateTime: timestamp
            };

            getSessionURL = `${SERVER.API_BASE_URL}${SERVER.SERVICES.QR_SESSION_ID}/${sessionIdStored}`;

            axios.put(getSessionURL, postBody, authConfig)
                .then(response => {
                    console.log("response of update qrsession", response);
                    resolve(response);
                })
                .catch(error => {
                    console.log("error of update qrsession", error);
                    reject(error);
                });

        } else {
            getSessionURL = `${SERVER.API_BASE_URL}${SERVER.SERVICES.QR_SESSION_ID}`;

            axios.post(getSessionURL, timestamp, authConfig)
                .then(response => {
                    console.log("response of qrcode session", response);
                    setQRSessionId(response.data);
                    resolve(response);
                })
                .catch(error => {
                    console.log("error of fms count", error);
                    reject(error);
                });
        }
    });
};

const getQRSessionforAuthorized = (userId) => {
    return new Promise((resolve, reject) => {
        let getSessionURL = "";
        const hostname = window && window.location && window.location.hostname;
        const environmentConstants = apiConfig.setEnvironmentURLs(hostname);
        let authConfig = {
            headers: {
                "X-API-KEY": environmentConstants.apiKey,
                'Content-Type': 'application/json',
            }
        };
            let sessionIdStored = getQRSessionId();
            let postBody = {
                qrSessionId: sessionIdStored,
                isFormSubmitted: false,
                isValidExcel: false,
                isPdfGenerated: false,
                pdfGenerationDateTime: null,
                isAuthenticated:true,
                isAuthorized: true,
                userId: userId
            };

            getSessionURL = `${SERVER.API_BASE_URL}${SERVER.SERVICES.QR_SESSION_ID}/${sessionIdStored}`;

            axios.put(getSessionURL, postBody, authConfig)
                .then(response => {
                    console.log("response of update qrsession", response);
                    resolve(response);
                })
                .catch(error => {
                    console.log("error of update qrsession", error);
                    reject(error);
                });

        
       
    });
};


const setQRSessionId = (sessionId) => {
    localStorage.setItem("qrSessionId",JSON.stringify(sessionId));
}

const getQRSessionId = () =>{
    return JSON.parse(localStorage.getItem("qrSessionId"))
}

const clearQRSessionId = () => {
    localStorage.removeItem("qrSessionId");
}

export {getQRSession,clearQRSessionId,getQRSessionId,getQRSessionforAuthorized}



